<template>
  <div class="AdminDashboard">
    <div class="row">
      <div class="col">
        <div class="alert alert-success">
          Total Income Today: {{ totalRevenueToday | toDollarAmount }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-9">
        <div class="row">
          <div class="col-12 col-lg-5">
            <div class="card">
              <h5 class="card-header">
                Date Range
              </h5>
              <div class="content">
                <date-range-input
                  ref="dateRange"
                  :value="selectedDates"
                  :options="{ required: true }"
                  @input="getStats($event)">
                </date-range-input>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="btn-group-toggle mb-2" data-toggle="buttons">
              <label
                class="btn btn-secondary"
                :class="{ 'active': period === 'day' }">
                <input @click="refreshStats('day')" type="radio" id="option1">
                  Today
              </label>
              <label
                class="btn btn-secondary"
                :class="{ 'active': period === 'week' }">
                <input @click="refreshStats('week')" type="radio" id="option2">
                  Past Week
              </label>
              <label
                class="btn btn-secondary"
                :class="{ 'active': period === 'month' }">
                <input @click="refreshStats('month')" type="radio" id="option3">
                  Past Month
              </label>
              <label
                class="btn btn-secondary"
                :class="{ 'active': period === 'threeMonths' }">
                <input @click="refreshStats('threeMonths')" type="radio" id="option4">
                  Past 3 Months
              </label>
              <label
                class="btn btn-secondary"
                :class="{ 'active': period === 'sixMonths' }">
                <input @click="refreshStats('sixMonths')" type="radio" id="option5">
                  Past 6 Months
              </label>
              <label
                class="btn btn-secondary"
                :class="{ 'active': period === 'year' }">
                <input @click="refreshStats('year')" type="radio" id="option6">
                  Past Year
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="card">
              <div class="content">
                <chart
                  :currency="true"
                  :labels="incomeData.labels"
                  title='Income Data ($ amount per day)'
                  :datasets="incomeData.datasets"
                  ref="incomeData" :type="'bar'"
                  :scales="incomeChartScale">
                </chart>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="card">
              <div class="content">
                <chart
                  :labels="volumeData.labels"
                  title='Quote Orders (Number of orders per day)'
                  :datasets="volumeData.datasets"
                  ref="volumeData" :type="'bar'"
                  :scales="incomeChartScale">
                </chart>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="card">
              <div class="content">
                <chart
                  :labels="reportData.labels"
                  title='Reports Data (Reports sent per day)'
                  :datasets="reportData.datasets"
                  ref="reportData" :type="'bar'"
                  :scales="incomeChartScale">
                </chart>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="card">
              <div class="content">
                <chart
                  :labels="quoteTypeData.labels"
                  title='Quotes Requested by Quote Type'
                  :datasets="quoteTypeData.datasets"
                  ref="quoteTypeData" :type="'pie'">
                </chart>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card">
              <div class="content">
                <chart
                  :labels="quoteTypeRevenueData.labels"
                  title='Quotes Revenue by Quote Type'
                  :datasets="quoteTypeRevenueData.datasets"
                  ref="quoteTypeRevenueData" :type="'pie'">
                </chart>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-3">
        <h3><i class="fa fa-history"></i> Recent Activity
          <router-link :to="'liveFeed'" class="btn btn-secondary btn-sm pull-right my-2">View All Activity</router-link>
        </h3>
        <search-form
          ref="searchform"
          :options="{
            permalink: 'liveFeed',
            inDetail: false,
            iconSize: '3x'
          }">
        </search-form>
      </div>
    </div>
  </div>
</template>

<script>
  import { LOAD_STATS } from '@/vuex/types'
  import { mapGetters } from 'vuex'
  import Chart from '@/components/displays/Chart'
  import DateRangeInput from '@/components/inputs/DateRangeInput'
  import SearchForm from '@/components/SearchForm'
  export default {
    name: 'AdminDashboard',
    components: {
      DateRangeInput,
      Chart,
      SearchForm
    },
    data () {
      return {
        myChart: '',
        period: 'month',
        options: {
          useEasing: true,
          useGrouping: true,
          separator: ',',
          decimal: '.',
          prefix: '',
          suffix: ''
        },
        timer: '',
        timePassed: 0,
        loadedTime: moment(),
        incomeChartScale: {
          yAxes: [{
            stacked: true,
            ticks: {
              beginAtZero: true
            }
          }],
          xAxes: [{
            stacked: true
          }]
        },
        selectedDates: {
          startDate: moment().subtract(1, 'month'),
          endDate: moment()
        }
      }
    },
    computed: {
      ...mapGetters([
        'stats'
      ]),
      incomeData () {
        return {
          ...this.stats.incomeData
        }
      },
      volumeData () {
        return {
          ...this.stats.volumeData
        }
      },
      reportData () {
        return {
          ...this.stats.reportData
        }
      },
      quoteTypeData () {
        return {
          ...this.stats.quoteTypeData
        }
      },
      quoteTypeRevenueData () {
        return {
          ...this.stats.quoteTypeRevenueData
        }
      },
      totalRevenueToday () {
        return this.stats.totalRevenueToday
      }
    },
    beforeDestroy () {
      clearInterval(this.autoReloadTimer)
    },
    methods: {
      // getNow () {
      //   this.timePassed = moment().diff(this.loadedTime, 'minutes')
      // },
      async getStats (eventData) {
        this.selectedDates.startDate = eventData.startDate
        this.selectedDates.endDate = eventData.endDate
        let payload = {}
        payload.selectedDates = this.selectedDates
        await this.$store.dispatch(LOAD_STATS, payload)
        await this.$nextTick()
        if (this.$refs.volumeData && this.$refs.incomeData) {
          this.$refs.volumeData.refresh()
          this.$refs.incomeData.refresh()
          this.$refs.reportData.refresh()
          this.$refs.quoteTypeData.refresh()
          this.$refs.quoteTypeRevenueData.refresh()
          this.autoReloadTimer = setInterval(this.getNow, 60000)
        }
      },
      refreshStats (period) {
        let payload = {}
        this.period = period
        switch (period) {
          case 'day':
            payload.startDate = moment()
            break
          case 'week':
            payload.startDate = moment().subtract(6, 'days')
            break
          case 'month':
            payload.startDate = moment().subtract(1, 'month')
            break
          case 'threeMonths':
            payload.startDate = moment().subtract(3, 'months')
            break
          case 'sixMonths':
            payload.startDate = moment().subtract(6, 'months')
            break
          case 'year':
            payload.startDate = moment().subtract(1, 'year')
            break
        }
        payload.endDate = moment()
        this.$refs.dateRange.setDateRange(payload)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/admin/AdminDashboard.vue